'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
/*eslint-disable sort-keys */
var sellerSortOrders = {
    UPCOMING_LOWEST_FIRST: 'UPCOMING_LOWEST_FIRST',
    UPCOMING_HIGHEST_FIRST: 'UPCOMING_HIGHEST_FIRST',
    NAME_LOWEST_FIRST: 'NAME_LOWEST_FIRST',
    NAME_HIGHEST_FIRST: 'NAME_HIGHEST_FIRST'
};

exports.default = sellerSortOrders;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/enums/sellerSortOrders.js
// module id = M8Jj
// module chunks = 57